import { useEffect } from "react";

/**
 * GoogleAnalytics — Loads gtag.js and initializes GA4 tracking.
 * Same pattern as TallyPopup to bypass platform proxy script-stripping.
 */
export default function GoogleAnalytics({ measurementId = "G-L8R7WSYR5P" } = {}) {
  useEffect(() => {
    if (typeof window === "undefined" || !measurementId) return;

    // Initialize dataLayer + gtag stub BEFORE the script loads
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", measurementId);

    // Avoid double-inject (hot-reload / route change)
    if (document.querySelector(`script[data-ga-id="${measurementId}"]`)) {
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    script.setAttribute("data-ga-id", measurementId);
    document.head.appendChild(script);

    // No cleanup — GA should persist across the session.
  }, [measurementId]);

  return null;
}
